import React from 'react'
import PropTypes from 'prop-types'

const BottomComponent = ({ children, title }) => {
  return (
    <div className='bottom-component'>
      <h4 className='text-ds-h3'>{title}</h4>
      {children}
    </div>
  )
}

BottomComponent.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
}

export default BottomComponent
